<script>
import VDataTableHistory from "@/components/VDataTable/VDataTableHistory.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VDialogDiff from "@/components/commonComponents/VDialogDiff.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";

export default {
    name: "History",
    components: {
        AjaxLoad,
        VDataTableHistory,
        VDialogDiff
    },
    mixins: [
        ComponentsKeys,
    ],
    props: {
        url: {
            type: String,
        },
        tableProps: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            componentsKeys: {
                diffModal: this.getRandomKey('diffModal'),
            },
        };
    },
    methods: {
        load() {
            this.$refs.ajax.load();
        },
        doShowDiffModal(item) {
            /**
             * @TODO Не хорошо так вызывать ф-цию, prettyPrintBySqlType очень просится в src/mixins/NumberFormat.js, а сам NumberFormat.js хочет переименоваться в какой-нибудь Formatter...
             */
            this.$refs.diffModal.show(this.$refs.table.prettyPrint(item.old, item.field_data_type), this.$refs.table.prettyPrint(item.new, item.field_data_type))
                .finally(() => {
                    this.updateComponentKey('diffModal');
                });
        },
        onDblClickRow(e, {item}) {
            this.doShowDiffModal(item);
        },
    },
}
</script>

<template>
    <div>
        <ajax-load
            ref="ajax"
            :url="url"
            :transform="response => response.data.data"
            v-slot="{data, resolved}"
        >
            <v-data-table-history
                :loading="!resolved"
                :items="data"
                @click:reload="() => $refs.ajax.load()"
                @dblclick:row="onDblClickRow"
                ref="table"
                v-bind="tableProps"
            ></v-data-table-history>
        </ajax-load>

        <v-dialog-diff
            ref="diffModal"
        ></v-dialog-diff>
    </div>
</template>

<style scoped lang="scss">

</style>
